import { click } from '@testing-library/user-event/dist/click'
import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import './NavBar.css';
import { Button } from './Button';

function NavBar() {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true)

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if(window.innerWidth <= 960){
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const openPdf = () => {
    const pdfPath = './resume.pdf';
    
    window.open(pdfPath, '_blank');
  };

  useEffect(() => {
    showButton()
  }, []);

  window.addEventListener('resize', showButton);

  return (
    <>
      <nav className='navbar'>
          <div className='navbar-container'>
            <Link to="/" className='navbar-logo' onClick={closeMobileMenu}>
                DMF
            </Link>
            <div className='menu-icon' onClick={handleClick}>
              <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
            </div>
            <ul className={click ? 'nav-menu active' : 'nav-menu'}>
              <li className='nav-item'>
                <Link to='/about-me' className='nav-links' onClick={closeMobileMenu}>
                  About Me
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/projects' className='nav-links' onClick={closeMobileMenu}>
                  Projects
                </Link>
              </li>
              <li className='nav-item'>
                <Link to='/' className='nav-links-mobile' onClick={(closeMobileMenu, openPdf)}>
                  Resume
                </Link>
              </li>
            </ul>
            {button && <Button buttonStyle='btn--outline' onClick={openPdf}>Resume</Button>}
          </div>
      </nav>
    </>
  )
}

export default NavBar
